import { MantineColor } from '@mantine/core';
import { PropertyType } from 'pages/ManageSmartAssistant/Sections/ToolsSection/ToolConfigurationPanels/CustomApiRequestToolConfigurationPanel/JsonSchemaBuilder/properties/types';
import { JsonSchema } from 'pages/ManageSmartAssistant/Sections/ToolsSection/ToolConfigurationPanels/CustomApiRequestToolConfigurationPanel/JsonSchemaBuilder/types';

export const MAX_NESTING_LEVEL = 3;

export const DEFAULT_JSON_SCHEMA: JsonSchema = {
  type: 'object',
  properties: {},
  required: [],
  additionalProperties: false
};

export const TYPE_COLORS: Record<PropertyType, MantineColor> = {
  string: 'green',
  number: 'blue',
  boolean: 'orange',
  object: 'violet',
  array: 'cyan'
} as const;
